export default [
	{
		name: 'integrations-transactions',
		path:
			'/integrations/thirdparties/:partyId/:thirdPartyId?/:integrationId?/:siteBodId?/transactions',
		props: route => ({
			partyId: route.params.partyId,
			companyId: parseInt(route.query.companyId) || 0,
			minDatetime: route.query.minDatetime,
			maxDatetime: route.query.maxDatetime,
			dealershipGroupGuid: route.query.dealershipGroupGuid || null,
			bodType: route.query.bodType || null,
			level: route.query.level || 'INFO',
			page: parseInt(route.query.page) || 1,
			countPerPage: parseInt(route.query.countPerPage) || 10,
			orderBy: route.query.orderBy || 'timestamp',
			orderDirection: route.query.orderDirection || 'desc',
			integrationId: parseInt(route.params.integrationId) || 0,
			thirdPartyId: parseInt(route.params.thirdPartyId) || 0,
			siteBodId: parseInt(route.params.siteBodId) || 0
		}),
		component: () =>
			import(
				/* webpackChunkName: "viewReport" */ '@/sections/integration/transactions/transactions-page.vue'
			),
		meta: {
			permissions: ['integration.read']
		}
	}
];
